import O1HD from "../../../../engines/gameEngine";
import {loveStoryPeople, loveStoryPeopleMap, WithdrawChooseOption} from "./loveStoryConst";
import WithdrawItemNode from "./WithdrawItemNode";
import AddWithdrawCount from "./AddWithdrawCount";

const {ccclass, property} = cc._decorator;
/**
 * 提现节点
 */
@ccclass
export default class WithdrawNode extends cc.Component {

    @property({type:cc.Label,displayName:"数字"})
    labelNum : cc.Label = null;
    @property({type:cc.Node,displayName:"键盘Node"})
    keyBoardNode : cc.Node = null;
    @property({type:cc.Node,displayName:"选项Item"})
    chooseItemNode : cc.Node = null;
    @property({type:cc.Node,displayName:"内容节点"})
    contentNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"添加提现次数"})
    addWithdrawCountPrefab : cc.Prefab = null;

    //完成回调
    mCompleteFun = null;
    mPeopleMap: loveStoryPeople = null;

    onLoad () {
        O1HD.on("WithdrawNode.refreshData" , this.refreshData , this );
    }

    start () {
        this.keyBoardNode.y = -1100;
        cc.tween(this.keyBoardNode)
            .to( 0.3,{ y : -510 })
            .start();
    }

    /**
     * 刷新数据
     */
    refreshData(){
        for ( let item of this.mPeopleMap.withdrawOptionArray ) {
            let chooseOptionNode = cc.instantiate( this.chooseItemNode );
            chooseOptionNode.getComponent( WithdrawItemNode ).bindData( this , item );
            chooseOptionNode.active = true;
            this.contentNode.addChild( chooseOptionNode );
        }
        this.refreshLabelNum();
    }

    /**
     * 完成回调
     * @param completeFun
     */
    bindData( peopleMap: loveStoryPeople , completeFun){
        this.mPeopleMap = peopleMap;
        this.mCompleteFun = completeFun;
        this.refreshData();
    }

    //刷新 机会次数
    refreshLabelNum(){
        this.labelNum.string = `${this.mPeopleMap.currDayWithdraw}`;
    }

    //检查是否今日还有机会
    checkLabelNum(){
        if ( this.mPeopleMap.currDayWithdraw < 1 ) {
            return true;
        }
        return false;
    }

    /**
     * 添加提现次数预制体
     */
    addWithCountPrefab ( withdrawChooseOption : WithdrawChooseOption) {
        let addWithdrawCountPrefabNode = cc.instantiate( this.addWithdrawCountPrefab );
        addWithdrawCountPrefabNode.getComponent( AddWithdrawCount ).bindData( this.mPeopleMap , withdrawChooseOption ,this );
        this.node.addChild( addWithdrawCountPrefabNode );
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }

    _close(){
        cc.tween(this.keyBoardNode)
            .to( 0.3,{ y : -1100 },{easing:'fade'})
            .call(()=>{
                this.contentNode.removeAllChildren();
                this.contentNode.destroyAllChildren();
                this.node.removeFromParent();
                this.node.destroy();
            })
            .start();
    }

}
